import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectToken } from "../../../../../../redux-store/selectors";
import {
  getStoreWorkingHoursAction,
} from "../../../../constants/actions";
import {
  getStoreWorkingHoursSuccess,
  getStoreWorkingHoursFailure,
  getStoreWorkingHours,
} from "../../../actions/Manager";
import {
  getStoreWorkingHours as getStoreWorkingHoursReq,
} from "../../../../axios/Manager";
import { union } from "ts-action";

const actionTypes = union({ getStoreWorkingHours });
function* getStoreWorkingHoursSaga({ payload: scheduleId }: typeof actionTypes) {
  try {
    const token = yield select(selectToken);
    const res = yield call(getStoreWorkingHoursReq, token, scheduleId);
    const selectedScheduleId = yield select(
      (state: {
        workingHoursScheduleReducer: {
          selectedWorkingHoursSchedule?: { id?: string };
        };
      }) => state.workingHoursScheduleReducer.selectedWorkingHoursSchedule?.id
    );
    if (selectedScheduleId !== scheduleId) {
      return;
    }
    yield put(getStoreWorkingHoursSuccess(res.data));
  } catch (error) {
    yield put(getStoreWorkingHoursFailure(error as Error));
  }
}

export function* watchGetStoreWorkingHours() {
  yield takeLatest(
    getStoreWorkingHoursAction.requested,
    getStoreWorkingHoursSaga
  );
}